import { render } from "./News.vue?vue&type=template&id=7ded6e24"
import script from "./News.vue?vue&type=script&lang=ts"
export * from "./News.vue?vue&type=script&lang=ts"

import "./News.vue?vue&type=style&index=0&id=7ded6e24&lang=scss"
script.render = render

export default script